import { VLabel } from 'vuetify/lib/components/VLabel';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VLabel,[(_vm.caption)?_c('span',[_vm._v(_vm._s(_vm.caption))]):_vm._e(),_c('load-image',{key:_vm.renderKey,class:_vm.componentClasses,attrs:{"media-context-item-id":_vm.orgId,"maxWidth":_vm.imageSize.width,"maxHeight":_vm.imageSize.height,"media-context":"organization-logo"},on:{"click":_vm.sendToDashboard}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }